<div class="dropdown" ngxClickElsewhere (clickElsewhere)="isDropDown = false">
  <div class="dropdown__btn" (click)="onToggle()">
    <div>{{ activeTitle || 'Izaberi operaciju' }}</div>
    <div [class.dropdown__arrow]="isDropDown">
      <i class="fa fa-chevron-down"></i>
    </div>
  </div>
  <div class="dropdown__list" [class.dropdown__list--visible]="isDropDown">
    <label class="dropdown__item" *ngFor="let option of options; trackBy: trackByFunction"
           (change)="isDropDown = false">
      <input class="selectgroup-input" type="radio"
             [value]="option" (click)="onSelectOption(option)">
      <span *ngIf="isExtendedData">
        {{ option?.client }}-
        {{ option?.workOrderName }}-
        {{ option?.workOrderUpisId }}-
        </span>
      {{ option.name }}
    </label>
  </div>
</div>
